<template>
  <div
    v-if="founder"
    :class="`founder-intro--${size}`"
    class="founder relative c-text founder-intro flex-column flex-middle bg-bg-5 padding-l-horizontal padding-xs-top padding-s-bottom">
    <div class="media-slider relative flex flex-center">
      <slider
        v-if="founder?.FounderMedia && founder?.FounderMedia?.length > 0"
        ref="imageSlider"
        class="image-slider animate__fadeIn animate--delay-200"
        style="z-index: var(--z-1)"
        :config="mediaSliderConfig">
        <template #default>
          <slide v-for="(founderMediaItem, index) in displayMedia" :key="index">
            <div
              class="flex-center flex-middle padding-xs"
              :class="{ 'first-slider-image': index === 0 }"
              style="height: 100%; width: 100%">
              <img
                loading="lazy"
                class="founder-intro-image"
                :src="founderMediaItem?.Media?.thumbUrl"
                :alt="founderMediaItem.title" />
            </div>
          </slide>
        </template>
        <template #navigation-prev>
          <span style="display: none"></span>
        </template>
        <template #navigation-next>
          <span style="display: none"></span>
        </template>
      </slider>
      <div
        v-if="hasMultipleMedia"
        class="swiper-button-prev-custom padding-xs"
        @click.prevent.stop="$refs['imageSlider'].prev()">
        <icon icon="chevron-inline-start" :size="2" theme="lead"></icon>
      </div>
      <div
        v-if="hasMultipleMedia"
        class="swiper-button-next-custom padding-xs"
        @click.prevent.stop="$refs['imageSlider'].next()">
        <icon icon="chevron-inline-end" :size="2" theme="lead"></icon>
      </div>
    </div>
    <div class="founder-data flex-column flex-middle text-center relative">
      <h3
        class="founder-name block text-bold"
        style="">
        {{ translateTitleCase(founder.fullName) }}
      </h3>
      <div
        class="founder-meta flex-column flex-middle text-center relative"
        style="

        ">
        <span
          v-if="founder.originCountry && founder.originCountry != ''"
          class="founder-country block text-center">
          {{ translateUcFirst(founder.originCountry) }}
        </span>
        <div class="separator block"></div>
        <span
          v-if="founder.birthYear && founder.birthYear != '0'"
          class="founder-tagline block text-xs text-center">
          <span>{{ founder.birthYear }}</span>
          <span v-if="founder.deathYear && founder.deathYear !== '0'"
            >&nbsp;-&nbsp;</span
          >
          <span v-if="founder.deathYear && founder.deathYear !== '0'">{{
            founder.deathYear
          }}</span>
        </span>

      </div>
    </div>
    <div class="founder-zoom-container">
      <icon icon="magnify-plus" :size="size === 's' ? 1.5 : 2.0"></icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    founder: {
      type: [Object, Boolean],
      default: false,
    },
    size: {
      type: String,
      default: "s",
    },
  },
  data: function () {
    return {
      uid: new Date().getTime() + "_" + utilities.getUniqueNumber(),
      mediaSliderConfig: {
        loop: true,
        //slidesPerView: 1,
        // spaceBetween: 20,
        breakpoints: {
          767: {
            // slidesPerView: 3,
          },
        },
        pagination: false,
        observer: true,
        observeParents: true,
        parallax: true,
        // Navigation arrows
        // navigation: {
        // nextEl: ".swiper-button-next-custom",
        //prevEl: ".swiper-button-prev-custom",
        //  },
      },
    };
  },
  computed: {
    displayMedia() {
      if (
        !this.founder ||
        !this.founder.FounderMedia ||
        !Array.isArray(this.founder.FounderMedia)
      ) {
        return [];
      }

      let featuredItem = false;
      let result = [];
      this.founder.FounderMedia.forEach((item) => {
        if (item.featured) {
          featuredItem = item;
          return true;
        }

        result.push(item);
      });

      if (featuredItem) {
        result.unshift(featuredItem);
      }
      return result;
    },
    hasMultipleMedia() {
      return this.displayMedia.length > 1;
    },
  },
  watch: {
    founder: {
      handler() {
        if (utilities.isSSR()) {
          this.$nextTick(() => {
            this.resetSliders();
          });
        } else {
          setTimeout(() => {
            this.resetSliders();
          }, 200);
        }
      },
      deep: true,
    },
  },
  methods: {
    resetSliders() {
      try {
        this.$refs["imageSlider"].reset();
        if (this.$refs["imageSlider"]) {
          this.$refs["imageSlider"].reset();
        }
      } catch (e) {}
    },
  },
};
</script>

<style scoped lang="scss">
.founder-intro {
  .media-slider {
    height: calc(var(--base-margin) * 90);
    width: calc(var(--base-margin) * 130);
  }

  .founder-intro-image {
    height: 100%;
    width: 100%;
    max-height: calc(var(--base-margin) * 75);
    max-width: calc(var(--base-margin) * 100);
    object-fit: contain;
  }

  .first-slider-image .founder-intro-image {
    max-height: calc(var(--base-margin) * 90);
    max-width: calc(var(--base-margin) * 110);
    object-fit: contain;
  }

  .founder-data {
    width: 100%;

    .founder-name {
      margin-bottom: var(--margin-xs);
      font-size: calc(var(--font-l) * 0.8);
    }
  }

  .founder-meta {
    width: calc(100% - (var(--base-margin) * 70));
    min-height: calc(var(--base-margin) * 20);
    min-width: calc(var(--base-margin) * 94);

    .founder-tagline {
      font-size: calc(var(--font-xs) * 0.9)
    }

    .founder-country {
      font-size: calc(var(--font-s) * 0.85);
    }
    .separator {
      width: 80%;
      max-width: calc(var(--base-margin) * 60);
      height: 1px;
      background: var(--c-text);
      margin-top: var(--margin-xs);
      margin-bottom: var(--margin-xs);
    }


  }

  .swiper-button-prev-custom {
    position: absolute;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
    margin-inline-end: calc(100% + (var(--base-margin) * 4));
    z-index: var(--z-3);

    &::after {
      display: none;
    }
  }

  .swiper-button-next-custom {
    position: absolute;
    top: 50%;
    cursor: pointer;
    transform: translateY(-50%);
    margin-inline-start: calc(100% + (var(--base-margin) * 4));
    z-index: var(--z-3);

    &::after {
      display: none;
    }
  }

  .founder-zoom-container {
    position: absolute;
    bottom: var(--margin-xs);
    inset-inline-start: var(--margin-xs);
  }

  &--l {
    padding-top: var(--margin-m) !important;
    padding-bottom: var(--margin-m) !important;

    .media-slider {
      height: calc(var(--base-margin) * 130);
      width: calc(var(--base-margin) * 180);
    }

    .founder-intro-image {
      max-height: calc(var(--base-margin) * 130);
      max-width: calc(var(--base-margin) * 180);
    }

    .first-slider-image .founder-intro-image {
      max-height: calc(var(--base-margin) * 130);
      max-width: calc(var(--base-margin) * 180);
    }

    .swiper-button-prev-custom {
      margin-inline-end: calc(100% + (var(--base-margin) * 24));
    }

    .swiper-button-next-custom {
      margin-inline-start: calc(100% + (var(--base-margin) * 24));
    }

    .founder-data {
      margin-top: var(--margin-m);
      margin-bottom: var(--margin-s);
      .founder-name {
        font-size: calc(var(--font-l) * 1);

      }
    }

    .founder-meta {
      .founder-tagline {
        font-size: calc(var(--font-s))
      }

      .founder-country {
        font-size: calc(var(--font-s) * 1);
      }
    }

    .founder-zoom-container {
      position: absolute;
      bottom: var(--margin-xs);
      inset-inline-start: var(--margin-m);
    }
  }
}
</style>
<style lang="scss"></style>
